import { shadow, typeScale } from './tokens.js'

/**
 * tailwind-merge config for the preset's custom utilities. Without it twMerge treats `text-caption` as a text
 * colour and drops it when a colour class (`text-ink`) follows, and does the same to `shadow-card` vs shadow colours.
 * Use with extendTailwindMerge(adminMergeConfig) in each app's cn().
 */
export const adminMergeConfig = {
  extend: {
    classGroups: {
      'font-size': [{ text: Object.keys(typeScale) }],
      shadow: [{ shadow: Object.keys(shadow) }],
    },
  },
}
